export default {
    validate(self) {
        const hlaValuesCount = self.form.hlas.filter(function(item) {
            return item.secondAllele || item.firstAllele;
          }).length;
                
        let hlaErrors = 0;

        this.emptyValidation(self.form.hlas);

        self.form.hlas.forEach(function(item) {
            const firstAllele = item.hlaTypeName + 'firstAllele';
            const secondAllele = item.hlaTypeName + 'secondAllele';
            const hlaValid = !self.$validator.errors.has(firstAllele)
              && !self.$validator.errors.has(secondAllele)
              && item.firstAlleleValid
              && item.secondAlleleValid;

            hlaErrors += (hlaValid ? 0 : 1);
        }, self);

        return hlaErrors == 0 && hlaValuesCount > 0;
    },

    emptyValidation(hlas, source){
        hlas.forEach(function(item) {
            if(!item.firstAllele && !item.isFirstAllelleTouched && item.secondAllele) {
                if (item.isFirstAllelleTouched) {
                    item.firstAlleleValid = false;
                } else {
                    item.firstAlleleValid = true;
                }
            } else {
                item.firstAlleleValid = true;
            }

            if(!item.secondAllele && item.firstAllele) {
                if (item.isSecondAllelleTouched) {
                    item.secondAlleleValid = false;
                } else {
                    item.secondAlleleValid = true;
                }
            } else {
                item.secondAlleleValid = true;
            }

            if (item.sortValue !== source) {
                if (item.firstAllele && !item.secondAllele) {
                    item.secondAlleleValid = false;
                }

                if (!item.firstAllele && item.secondAllele) {
                    item.firstAlleleValid = false;
                }
            }
        }); 
    }
}
